<template>
    <WorkSchedulePosition
        v-for="workSchedulePosition in workSchedulePositions"
        :key="rowIndex + '|' + workSchedulePosition.id"
        :row="rowIndex + 1"
        :workSchedulePosition="workSchedulePosition"
        :renderedDateRange="renderedDateRange"
        :groupLabels="groupLabels"
        @dragStart:workSchedulePosition="$emit('dragStart:workSchedulePosition', $event)"
        @dragEnd:workSchedulePosition="$emit('dragEnd:workSchedulePosition', $event)"
    />
</template>

<script lang="ts">
    import WorkSchedulePosition from '@/components/WorkSchedule/WorkSchedulePosition.vue';
    import {PlanbordWorkScheduleGroupLabel, PlanbordWorkSchedulePosition} from '@/types/api-object-extensions';
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {DateRange} from '@/types/types';

    @Component({
        components: {
            WorkSchedulePosition,
        },
        emits: [
            'dragStart:workSchedulePosition',
            'dragEnd:workSchedulePosition',
        ],
    })
    export default class WorkSchedulePositionsPerGroupLabel extends Vue {
        @Prop({required: true}) public groupLabels!: Record<number, PlanbordWorkScheduleGroupLabel>;
        @Prop({required: true}) public workSchedulePositions!: PlanbordWorkSchedulePosition[];
        @Prop({required: true}) public renderedDateRange!: DateRange;
        @Prop({required: true}) public rowIndex!: number;
    }
</script>
